import React from "react";
import { Leaf, Sprout, Store, ArrowRight, LogOut, BookOpen } from "lucide-react";
import { useCookies } from 'react-cookie';

export default function Corridor() {
  const [cookies, , removeCookie] = useCookies(['name']);

  const logout = () => {
    removeCookie("username");
    window.location.href = "/login";
  };

  return (
    <div style={{
      minHeight: "100vh", background: "var(--gradient-hero)",
      display: "flex", alignItems: "center", justifyContent: "center", padding: "20px",
      fontFamily: "var(--font-sans)"
    }}>
      <div style={{ maxWidth: "800px", width: "100%" }}>
        <div style={{ textAlign: "center", marginBottom: "48px", animation: "fadeInUp 0.6s ease" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
            <div style={{ width: "40px", height: "40px", borderRadius: "12px", background: "var(--gradient-accent)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Leaf size={20} color="white" />
            </div>
            <span style={{ fontWeight: 800, fontSize: "24px", color: "white", letterSpacing: "-0.03em" }}>AGRIVESTIA</span>
          </div>
          <h1 style={{ fontSize: "clamp(32px, 5vw, 48px)", fontWeight: 900, color: "white", marginBottom: "16px", letterSpacing: "-0.02em" }}>
            Welcome Back!
          </h1>
          <p style={{ fontSize: "18px", color: "rgba(255,255,255,0.7)", maxWidth: "500px", margin: "0 auto" }}>
            How would you like to grow with Agrivestia today? Choose a path to continue.
          </p>
        </div>

        <div className="grid-mobile-1" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "24px" }}>
          {/* Investment Path */}
          <div
            onClick={() => window.location.href = "/dashboard"}
            className="card-glass"
            style={{
              padding: "40px", cursor: "pointer", transition: "all 0.3s ease",
              animation: "fadeInUp 0.8s ease", border: "1px solid rgba(255,255,255,0.1)"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.background = "rgba(255,255,255,0.15)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.background = "rgba(255,255,255,0.1)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
            }}
          >
            <div style={{ width: "56px", height: "56px", borderRadius: "16px", background: "var(--gradient-accent)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "24px" }}>
              <Sprout size={28} color="white" />
            </div>
            <h2 style={{ fontSize: "24px", fontWeight: 800, color: "white", marginBottom: "12px" }}>Investment Portal</h2>
            <p style={{ color: "rgba(255,255,255,0.6)", lineHeight: 1.6, marginBottom: "24px" }}>
              Manage your farm portfolio, track performance, and explore new high-yield agricultural opportunities.
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: 700, color: "#22c55e" }}>
              Enter Investment Hub <ArrowRight size={18} />
            </div>
          </div>

          {/* Marketplace Path */}
          <div
            onClick={() => window.location.href = "/market_dashboard"}
            className="card-glass"
            style={{
              padding: "40px", cursor: "pointer", transition: "all 0.3s ease",
              animation: "fadeInUp 1s ease", border: "1px solid rgba(255,255,255,0.1)"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.background = "rgba(255,255,255,0.15)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.background = "rgba(255,255,255,0.1)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
            }}
          >
            <div style={{ width: "56px", height: "56px", borderRadius: "16px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "24px" }}>
              <Store size={28} color="white" />
            </div>
            <h2 style={{ fontSize: "24px", fontWeight: 800, color: "white", marginBottom: "12px" }}>Central Marketplace</h2>
            <p style={{ color: "rgba(255,255,255,0.6)", lineHeight: 1.6, marginBottom: "24px" }}>
              Buy or sell agricultural produce. Post requests, browse products, and connect with trusted farmers and buyers.
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: 700, color: "white" }}>
              Go to Marketplace <ArrowRight size={18} />
            </div>
          </div>

          {/* Blog Path */}
          <div
            onClick={() => window.location.href = "/blog"}
            className="card-glass"
            style={{
              padding: "40px", cursor: "pointer", transition: "all 0.3s ease",
              animation: "fadeInUp 1.2s ease", border: "1px solid rgba(255,255,255,0.1)"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.background = "rgba(255,255,255,0.15)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.background = "rgba(255,255,255,0.1)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)";
            }}
          >
            <div style={{ width: "56px", height: "56px", borderRadius: "16px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "24px" }}>
              <BookOpen size={28} color="white" />
            </div>
            <h2 style={{ fontSize: "24px", fontWeight: 800, color: "white", marginBottom: "12px" }}>Health & News</h2>
            <p style={{ color: "rgba(255,255,255,0.6)", lineHeight: 1.6, marginBottom: "24px" }}>
              Stay updated with the latest in agritech, health tips, and community success stories.
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: 700, color: "white" }}>
              Read Our Blog <ArrowRight size={18} />
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "48px", animation: "fadeInUp 1.2s ease" }}>
          <button onClick={logout} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.5)", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "8px", fontSize: "14px", fontWeight: 500 }} onMouseEnter={e => e.target.style.color = "white"} onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.5)"}>
            <LogOut size={16} /> Sign out of Agrivestia
          </button>
          <div style={{ color: "rgba(255,255,255,0.3)", fontSize: "12px", marginTop: "24px" }}>
            © {new Date().getFullYear()} Agrivestia — Powered by Innovation in Agriculture
          </div>
        </div>
      </div>
    </div>
  )
}
